<template>
  <div class="auth-card">
    <div class="auth-card-header">
      <div v-if="title" class="auth-card-title">
        {{ title }}
      </div>
      <div v-if="subtitle" class="auth-card-subtitle">
        {{ subtitle }}
      </div>
    </div>

    <form class="auth-card-form" @submit.prevent="onSubmit">
      <slot />

      <div v-if="errors.items.length" class="auth-card-form-error">
        <i class="fas fa-exclamation-circle" />
        <slot name="error" />
      </div>

      <button
        v-if="submitLabel"
        type="submit"
        class="auth-card-button margin-auto"
        :disabled="disabled"
      >
        {{ submitLabel }}
      </button>
    </form>

    <slot name="card-footer" />
  </div>
</template>

<script>
export default {
  name: 'AuthCard',
  props: {
    title: { type: String, required: false, default: '' },
    subtitle: { type: String, required: false, default: '' },
    disabled: { type: Boolean, required: false, default: false },
    submitLabel: { type: String, required: false, default: '' },
    onSubmit: { type: Function, required: false, default: null }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.auth-card {
  &-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $scale600;
  }

  &-subtitle {
    @include ParagraphSmall;
    color: $neutral500;
    text-align: center;
  }

  &-form {
    display: flex;
    flex-direction: column;
    gap: $scale800;
    width: 100%;

    &-error {
      @include ParagraphSmall;
      color: $negative400;

      display: flex;
      align-items: center;
      gap: $scale300;

      margin: 0;
      margin-bottom: $scale600;
    }
  }

  .help-content {
    display: flex;
    justify-content: center;
    gap: $scale300;
    margin-top: $scale800;

    @include ParagraphSmall;
    color: $neutral500;

    &-action {
      @include ParagraphSmall;
      color: $neutral500;
      font-weight: 700;
      text-decoration: none;
      color: $blue200;
    }
  }
}
</style>
